module.exports = __webpack_public_path__ + "static/Salsify-f3860e8c162dce7787fa523ea0be7423.svg";